import React from 'react';
import { PhoneIcon, MailIcon } from 'lucide-react';
import { agent, listing, brand } from '../../../data/reportPhilly';
// Minimal footer: agent contact + a minimized Virtual Results attribution mark.
export function FooterV5() {
  return <footer className="mt-2" data-id="element-669" data-mp="3h6t2xrn9gmpy">
      <div className="border-t-[3px] border-bhhs-cab pt-6" data-id="element-670" data-mp="3m54c005qet74">
        <div className="flex flex-col gap-5 sm:flex-row sm:items-center sm:justify-between" data-id="element-671" data-mp="3m4kycvn46qyw">
          <div className="flex items-center gap-3.5" data-id="element-672" data-mp="2pgeyem150mqy">
            <img src={agent.avatar} alt={agent.name} className="size-12 rounded-full object-cover" data-id="element-673" data-mp="2tfxhdc9eenr5" />
            <div data-id="element-674" data-mp="2ye7e3rartwev">
              <p className="font-display text-lg font-semibold text-bhhs-cab" data-id="element-675" data-mp="2ydp7c0qhfzsp">
                {agent.name}
              </p>
              <p className="text-xs text-muted-foreground" data-id="element-676" data-mp="25re8ovmfs8yj">
                {agent.title} · {agent.brokerage}
              </p>
            </div>
          </div>
          <div className="flex flex-col gap-1.5 text-sm" data-id="element-677" data-mp="2anuuvka2sd8z">
            <a href={`tel:${agent.phone}`} className="inline-flex items-center gap-2 text-foreground hover:text-bhhs-cab" data-id="element-678" data-mp="3n51c79gnoe05">
              <PhoneIcon className="size-4" data-id="element-679" data-mp="3ediw0yjply72" /> {agent.phone}
            </a>
            <a href={`mailto:${agent.email}`} className="inline-flex items-center gap-2 text-foreground hover:text-bhhs-cab" data-id="element-680" data-mp="3ebo8rdkyttzt">
              <MailIcon className="size-4" data-id="element-681" data-mp="34ge5ynmqtikz" /> {agent.email}
            </a>
          </div>
        </div>

        {/* minimized Virtual Results attribution */}
        <div className="mt-6 flex items-center justify-center gap-2 border-t border-border pt-4" data-id="element-682" data-mp="2ven27obrjltr">
          <img src={brand.logoFull} alt={brand.product} className="h-5 w-auto object-contain opacity-60" data-id="element-683" data-mp="2qg3dxh9p5xy8" />
          <span className="text-[10px] text-muted-foreground" data-id="element-684" data-mp="tn1njg8yyoqq">
            · Marketing report for {listing.address}, {listing.cityState} · ©{' '}
            {brand.year} {brand.product}
          </span>
        </div>
      </div>
    </footer>;
}